module.exports = __webpack_public_path__ + "quilt2-level5.4b14181d.png";